import type { Components, Theme } from "@mui/material";

export const MuiListItemIcon: Components<Theme>["MuiListItemIcon"] = {
	variants: [
		{
			props: {},
			style: { minWidth: 0 },
		},
	],
};
